<template>
<div>
    <div class="waka-header">
      <!-- <router-link :to="'/menu'" class="btn btn-primary"><b-button type="is-light"> Menu</b-button></router-link>
      <span v-if="this.environment === 'TEST'" class="tag is-large" :class="classEnv">ENVIRONNEMENT DE TEST</span> -->
      <div v-if="currentUser !== null" class="currentUser">{{currentUser.name}}</div>
      <b-button type="is-light" @click="logout"> Quitter</b-button>
    </div>
    <b-modal :v-model="false" :width="700" scroll="keep" :can-cancel="true">
      <div class="card">
        <div class="card-header">
          <section class="hero-body">
            <div class="columns">
              <div class="column is-four-fifths">
                <div ref="finishElement" v-for="e in messages" :key="e.messageId">
                  <!-- <b-notification :type="e.messageType" has-icon aria-close-label="Close notification"> -->
                  <h2> {{e.message}}</h2>
                  <!-- </b-notification> -->
                </div>
              </div>
              <div class="column is-is-one-fifth" v-if="paymentStatus === 'finished'">
                <b-button type="is-success" @click="finishPayment">Terminer</b-button>
              </div>
            </div>
          </section>
        </div>
      </div>
    </b-modal>
    <section v-if="currentCustomer === null">
      <div class="columns mt-3">
        <div class="column hero ">
          <p>en cours de chargement... </p>
        </div>
      </div>
    </section>
    <section  v-if="currentCustomer !== null">
      <b-loading v-model="isLoading"></b-loading>
      <div class="columns mt-3">
        <div class="column hero ">
          <div class="hero-body widget widget-address">
            <h2>{{this.currentCustomer.sageCode}}</h2>
            <h2>{{this.currentCustomer.adress}}</h2>
            <h2>{{this.currentCustomer.complement}}</h2>
            <h2>{{this.currentCustomer.postalCode}} {{this.currentCustomer.city}}</h2>
          </div>
        </div>
        <div class="column hero">
          <div v-if="isPaymentPanelVisible === false" class="hero-body widget widget-solde">
            <form style="display:none" :action="bankUrl" method="POST" id="form"
              ref="bankForm">
              <input type="hidden" id="PBX_SITE" name="PBX_SITE" :value="bankParameters.PBX_SITE" />
              <input type="hidden" id="PBX_RANG" name="PBX_RANG" :value="bankParameters.PBX_RANG" />
              <input type="hidden" id="PBX_IDENTIFIANT" name="PBX_IDENTIFIANT" :value="bankParameters.PBX_IDENTIFIANT" />
              <input type="hidden" id="PBX_SOURCE" name="PBX_SOURCE" :value="bankParameters.PBX_SOURCE" />
              <input type="hidden" id="PBX_TOTAL" name="PBX_TOTAL" :value="bankParameters.PBX_TOTAL" />
              <input type="hidden" id="PBX_DEVISE" name="PBX_DEVISE" :value="bankParameters.PBX_DEVISE" />
              <input type="hidden" id="PBX_CMD" name="PBX_CMD" :value="bankParameters.PBX_CMD" />
              <input type="hidden" id="PBX_PORTEUR" name="PBX_PORTEUR" :value="bankParameters.PBX_PORTEUR" />
              <input type="hidden" id="PBX_RETOUR" name="PBX_RETOUR" :value="bankParameters.PBX_RETOUR" />
              <input type="hidden" id="PBX_HASH" name="PBX_HASH" :value="bankParameters.PBX_HASH" />
              <input type="hidden" id="PBX_TIME" name="PBX_TIME" :value="bankParameters.PBX_TIME" />
              <input type="hidden" id="PBX_EFFECTUE" name="PBX_EFFECTUE" :value="bankParameters.PBX_EFFECTUE" />
              <input type="hidden" id="PBX_REFUSE" name="PBX_REFUSE" :value="bankParameters.PBX_REFUSE" />
              <input type="hidden" id="PBX_ANNULE" name="PBX_ANNULE" :value="bankParameters.PBX_ANNULE" />
              <input type="hidden" id="PBX_ATTENTE" name="PBX_ATTENTE" :value="bankParameters.PBX_ATTENTE" />
              <input type="hidden" id="PBX_REPONDRE_A" name="PBX_REPONDRE_A" :value="bankParameters.PBX_REPONDRE_A" />
              <input type="hidden" id="PBX_BILLING" name="PBX_BILLING" :value="bankParameters.PBX_BILLING" />
              <input type="hidden" id="PBX_SHOPPINGCART" name="PBX_SHOPPINGCART" :value="bankParameters.PBX_SHOPPINGCART" />
              <input type="hidden" id="PBX_HMAC" name="PBX_HMAC" :value="bankParameters.PBX_HMAC" />
              <button class="btn btn-info" type="submit">submit</button>
            </form>
            <div class="columns">
              <div class="column is-6">
                <h2>Factures à échéance</h2>
              </div>
              <div class="column is-6">
                <h2>Solde total</h2>
              </div>
            </div>
            <div class="columns">
              <div class="column is-6">
                <h2>{{this.currentCustomer.balance | formatCurrency }}</h2>
              </div>
              <div class="column is-6">
                <h2>{{this.currentCustomer.balanceFull | formatCurrency }}</h2>
              </div>
            </div>
            <div class="columns">
              <div class="column is-6">
                <div v-if="this.currentCustomer.balance > 0">
                  <b-button class="" type="is-info" @click="startPayment(currentCustomer.balance)">Régler</b-button>
                </div>
              </div>
              <div class="column is-6">
                <div v-if="this.currentCustomer.balanceFull > 0">
                  <b-button class="" type="is-info" @click="startPayment(currentCustomer.balanceFull)">Régler</b-button>
                </div>
              </div>
            </div>
          </div>
            <div v-if="isPaymentPanelVisible === true" class="hero-body widget widget-payment">
              <h1>Paiement en cours</h1>
              <div class="columns">
                <div class="column is-vor-fifths">
                  <div  v-for="e in messages" :key="e.messageId">
                    <h2> {{e.message}}</h2>
                  </div>
                </div>
                <div class="column" v-if="isEndPayment === true">
                  <b-button type="is-large is-info" @click="finishPayment">Terminer</b-button>
                </div>
              </div>
            </div>
        </div>
      </div>
      <div>
      <b-tabs size="is-large"  style="background-color:white; margin:30px" v-model="activeTab">
        <b-tab-item  >
          <template #header>
            <div style="color: blue;">
                <b-icon icon="format-list-bulleted"></b-icon>
                <span> Comptable </span>
              </div>
            </template>
          <section class="hero is-small " style="margin-bottom:2px">
            <div class="hero-body columns waka-line ">
              <div class="column is-1">Date</div>
              <div class="column is-1">Type</div>
              <div class="column is-1">N° pièce</div>
              <div class="column is-4">Intitulé</div>
              <div class="column is-1">Echéance</div>
              <div class="column is-1">Débit</div>
              <div class="column is-1">Crédit</div>
            </div>
          </section>
          <section class="hero is-small " style="margin-bottom:2px" v-for="e in currentCustomer.accountingEntries"
            :key="e.sageId">
            <div class="hero-body columns waka-line">
              <div class="column is-1">{{e.date | formatDate}}</div>
              <div class="column is-1">{{e.entryType}}</div>
              <div class="column is-1">{{e.invoiceCode}}</div>
              <div class="column is-4">{{e.intitule}}</div>
              <div class="column is-1">{{e.dateTerm | formatDate}}</div>
              <div class="column is-1">{{(e.signedAmount> 0 ? '' :e.amount)}}</div>
              <div class="column is-1">{{(e.signedAmount> 0 ? e.amount : '')}}</div>
            </div>
          </section>
        </b-tab-item>
        <b-tab-item  label="" icon="format-list-bulleted">
          <template #header>
            <div style="color: green;">
                <b-icon icon="information-outline"></b-icon>
                <span> Vos factures / avoirs </span>
              </div>
            </template>
          <section class="hero is-small " style="margin-bottom:2px">
            <div class="hero-body columns waka-line ">
              <div class="column is-1">Date</div>
              <div class="column is-1">Type</div>
              <div class="column is-1">N° Facture</div>
              <div class="column is-1">Total TTC</div>
              <div class="column is-1">Echéance</div>
              <div class="column is-5">Pdf</div>
            </div>
          </section>
          <section class="hero is-small " style="margin-bottom:2px" v-for="e in currentCustomer.invoices"
            :key="e.sageId">
            <div class="hero-body columns waka-line">
              <div class="column is-1">{{e.date | formatDate}}</div>
              <div class="column is-1">{{e.invoiceType}}</div>
              <div class="column is-1">{{e.code}}</div>
              <div class="column is-1">{{e.amountTotal}}</div>
              <div class="column is-1">{{e.dateTerm | formatDate}}</div>
              <div class="column is-5">
                <div class="buttons">
                  <b-button v-if="e.invoiceCode !== ''" type="is-info" @click="getPdf(e.code)">Pdf</b-button>
                </div>
              </div>
            </div>
          </section>
        </b-tab-item>
      </b-tabs>
      </div>
    </section>
    <!-- <div class="waka-footer">
      <router-link :to="'/sandbox'" class="btn btn-primary">
        <b-button type="is-light"> Sandbox</b-button>
      </router-link>
    </div> -->
</div>
</template>
<script>
import { httpGet, httpPost } from '../wakasoft.js'
import Vue from 'vue'
export default {
  name: 'CustomerDashboard',
  data () {
    return {
      isPaymentPanelVisible: false,
      isPaymentInProcess: false,
      isEndPayment: false,
      bankParameters: [],
      messages: [],
      paymentStatus: '',
      withoutBank: false,
      activeTab: 0,
      paymentViewModel: null,
      bankUrl: ''
    }
  },
  filters: {
    formatDate: function (value) {
      return new Intl.DateTimeFormat('fr-FR').format(new Date(value))
    },
    formatCurrency: function (value) {
      return new Intl.NumberFormat('fr-FR', {
        style: 'currency',
        currency: 'EUR'
      }).format(value)
    }
  },
  computed: {
    currentUser () {
      return this.$store.getters.getCurrentUser
    },
    isLoading () {
      return this.currentCustomer === null
    },
    notificationType () {
      return this.notification.isSuccess ? 'is-success' : 'is-danger'
    },
    connection () {
      return this.$store.getters.getConnection
    },
    currentCustomer () {
      return this.$store.getters.getCurrentCustomer
    }
  },
  methods: {
    async startPayment (amount) {
      if (this.withoutBank === true) {
        try {
          var urlPayment = this.$store.state.API_BASE_URL + '/customer/create-sage-payment'
          this.paymentViewModel = { customerId: this.currentCustomer.sageId, customerCode: this.currentCustomer.sageCode, paymentAmount: amount }
          var jsonPayment = JSON.stringify(this.paymentViewModel)
          console.log(jsonPayment)
          await httpPost(urlPayment, jsonPayment)
          // loadingComponent.close()
          this.messages.push({ messageId: 3, message: 'paiement validé, cliquer sur le bouton terminer ', messageType: 'is-success' })
        } catch (err) {
          this.messages.push({ messageId: 3, message: 'validation impossible, contactez le service client SODIMED ', messageType: 'is-warning' })
        }
      } else {
      // on récupère les paramètres de banque
        try {
          this.paymentStatus = 'waiting'
          var url = this.$store.state.API_BASE_URL + '/bank/get-bank-url'
          console.log(url)
          this.bankUrl = await httpGet(url, {})
          url = this.$store.state.API_BASE_URL + '/bank/get-parameters'
          console.log(url)
          this.paymentViewModel = { customerId: this.currentCustomer.sageId, customerCode: this.currentCustomer.sageCode, paymentAmount: amount }
          var json = JSON.stringify(this.paymentViewModel)
          console.log(json)
          var result = await httpPost(url, json)
          this.bankParameters = result.reduce((a, x) => ({
            ...a,
            [x.name]: x.value
          }), {})
          await Vue.nextTick()
          this.$refs.bankForm.submit()
        } catch (err) {
          this.notification = {
            message: err.message,
            isSuccesss: false,
            isActive: true
          }
        }
      }
    },
    async finishPayment () {
      this.isPaymentPanelVisible = false
      this.$router.push('/customer-dashboard')
      this.loadData()
    },
    async getPdf (invoiceCode) {
      try {
        var url = this.$store.state.API_BASE_URL + '/document/get-pdf?code=' + invoiceCode + '&database=sodimed'
        window.open(url, '_blank')
        // console.log(pdf)
      } catch (err) {
        this.notification = {
          message: err.message,
          isSuccesss: false,
          isModalBankActive: true
        }
      }
    },
    async soldBalance () {
      this.isModalBankActive = true
    },
    async logout (e) {
      await this.$store.dispatch('setCurrentUser', null)
      // this.notification = { message: 'toto', isActive: true, isSuccess: false }
      window.localStorage.removeItem('sessionUser')
      window.localStorage.removeItem('sessionToken')
      window.localStorage.removeItem('sessionExpiry')
      this.$router.push('/')
    },
    async loadData () {
      try {
        await this.$store.dispatch('setCurrentCustomer', null)
        var url = this.$store.state.API_BASE_URL + '/customer/customer-get'
        var customer = await httpGet(url, {
          code: this.currentUser.code
        })
        console.log(customer)
        await this.$store.dispatch('setCurrentCustomer', customer)
      } catch (err) {
        this.notification = {
          message: err.message,
          isSuccesss: false,
          isActive: true
        }
      }
    },
    async callBack (bankCode, amount) {
      console.log(bankCode)
      this.isPaymentPanelVisible = true
      this.isEndPayment = false
      this.paymentStatus = 'done'
      if (bankCode === '00000') {
        this.messages.push({ messageId: 1, message: 'la transaction bancaire est terminée', messageType: 'is-success' })
        this.messages.push({ messageId: 2, message: 'validation du paiement en cours ...', messageType: 'is-info' })
        await Vue.nextTick()
        // const loadingComponent = this.$buefy.loading.open({
        //   container: this.$refs.finishElement.$el
        // })
        try {
          var url = this.$store.state.API_BASE_URL + '/customer/create-sage-payment'
          this.paymentViewModel = { customerId: this.currentCustomer.sageId, customerCode: this.currentCustomer.sageCode, paymentAmount: amount }
          var json = JSON.stringify(this.paymentViewModel)
          console.log(json)
          await httpPost(url, json)
          // loadingComponent.close()
          this.messages.push({ messageId: 3, message: 'paiement validé, cliquer sur le bouton terminer ', messageType: 'is-success' })
        } catch (err) {
          this.messages.push({ messageId: 3, message: 'validation impossible, contactez le service client SODIMED ', messageType: 'is-warning' })
        }
      } else {
        this.messages.push({ messageId: 1, message: 'la transaction bancaire a échoué', messageType: 'is-warning' })
        url = this.$store.state.API_BASE_URL + '/bank/get-callback-message'
        try {
          var callbackMessage = await httpGet(url, { code: bankCode })
          this.messages.push({ messageId: 2, message: callbackMessage.message, messageType: 'is-warning' })
        } catch (err) {
          this.messages.push({ messageId: 2, message: 'Erreur non spécifiée ', messageType: 'is-info' })
        }
        this.messages.push({ messageId: 3, message: 'terminer le traitement', messageType: 'is-info' })
      }
      this.paymentStatus = 'finished'
      this.isEndPayment = true
    }
  },
  async mounted () {
    if (window.localStorage.sessionUser) {
      const expiry = new Date(window.localStorage.sessionExpiry)
      const now = new Date()
      console.log(now)
      console.log(expiry)
      if (expiry < new Date()) {
        this.logout()
      }
      await this.$store.dispatch('setCurrentUser', { code: window.localStorage.sessionUser })
      await this.loadData()
      if (this.$route.query.Mt != null) {
        /* var amount = parseInt(this.$route.query.Mt) / 100
        var bankCode = window.location.href.substring(window.location.href.length - 5)
        console.log(window.location.href)
        console.log(bankCode)
        console.log(amount)
        await this.callBack(bankCode, amount) */
        console.log(window.location.href)
      }
    } else if (this.currentUser === null) {
      this.$router.push('/authentification-login')
    }
  }
}
</script>
